export const validation = (yup) => ({
  user: yup.string().required('Campo obrigatório')
})
